import { MEDIA } from 'src/utils/constants'
import styled from 'styled-components'

const { MOBILE_UP } = MEDIA

export const Form = styled.form`
  position: relative;
  width: 100%;
`

export const Footer = styled.footer`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  margin-top: 24px;
  flex-direction: column;
  gap: 16px;

  @media screen and ${MOBILE_UP} {
    justify-content: center;
  }
`

export const FormFields = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`
export const Link = styled.a`
  cursor: pointer;
  color: var(--cobasi-blue-light-9);
  font-family: var(--primary-font);
  font-style: normal;
  line-height: normal;
`

export const BlockLink = styled(Link)`
  display: block;
  width: fit-content;
  font-size: 12px;
  font-weight: 600;
  text-align: end;
  margin: 31px 16px 31px auto;
  text-decoration: underline;
  text-underline-offset: 5px
`
export const Info = styled.p`
  color: var(--gray-5);
  font-family: var(--primary-font);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  a {
    font-weight: 600;
  }
`
